import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ENV } from "./env";
import { MockAuthProvider, MsalAuthProvider } from "./auth";
import { Root } from "./Root";
import "@guestpilot/ui-kit/styles.css";

async function boot() {
  if (ENV.mock) {
    const { worker } = await import("./mocks/browser");
    await worker.start({ onUnhandledRequest: "bypass" });
  }
  const Auth = ENV.mock ? MockAuthProvider : MsalAuthProvider;
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <Auth>
        <Root />
      </Auth>
    </StrictMode>,
  );
}

void boot();
